export default {
	status: {
		All: "Tous",
		Pending: "En attente",
		Frozen: "Gelé",
		Completed: "Terminé",
		Undone: "Non effectué"
	},
	TotalAmount: "Montant total",
	Profit: "Profit",
	Expire: "Expirer"
};
